export const en = {
  'default.loading.text': 'Loading...',
  'compliance.status.tooltip.UNKNOWN': `We do not have enough data for a compliance statement.<br/> If you think you are compliant, please reach out to us.`,
  'compliance.status.tooltip.IGNORED':
    'Product Standard has not been checked because it is not listed in the cumulus-configuration.json as productStandardsToCheck',

  // compliance tiles + detail-dialogs --------------------------------------------------------------------------------

  'card.coverage.title': 'Cobertura/JaCoCo Coverage',

  'card.sonarqube.coverage.title': 'SonarQube Coverage',

  'default.error.text': 'Error loading information. Please try it again later.',
  'default.error.text.dialog': 'Oops... We ran into an problem and could not load this information. Please refresh or try again later!',
  // new fundamental cards

  'document.card.title': 'Documents',
  'document.card.download': 'Click to download file',
  'document.card.download.unauthorized':
    'You are not authorized to download the file.<br/><br/>You must be a workspace member with the role "owner" in Hyperspace portal or a pipeline responsible maintained in Hyperspace onboarding depending where your pipeline was setup.',

  // loading info

  'loading.info.microdeliveries.jira': 'Loading microdelivery entries from Jira.',

  // API Metadata Validator Card

  'card.api.metadata.validator.title': 'API Metadata Validator',

  // policy usage card

  'policy.usage.card.central.title': `Central Policy Usage`,
  'policy.usage.card.custom.title': `Custom Policy Usage`,

  // fosstars card
  'fosstar.card.title': 'Open Source Software Security Ratings',
  'fosstar.card.subtitle': 'Fosstars',

  // malwarescan card
  'malwarescan.card.title': 'Malware Scan Details',
  'malwarescan.card.subtitle': 'Malware Scan ',
  'malwarescan.details.title': 'Malware Scan Details ',
  'malwarescan.details.download.unauthorized':
    'You are not authorized to download the file.<br/><br/>You must be a workspace member with the role "owner" in Hyperspace portal or a pipeline responsible maintained in Hyperspace onboarding depending where your pipeline was setup.',

  // page sections -----------------------------------------------------------------------------------------------------

  // release selection
  'release-selection.combobox.all-versions.text': 'All Microdeliveries',
  'release-selection.open-microdelivery': 'Open Microdelivery',
  'release-selection.open-microdelivery.in-jira': 'Open Microdelivery in Jira',

  // group compliance modes
  'group-compliance-mode.latest': 'Latest Runs',
  'group-compliance-mode.latest-promoted': 'Latest Promoted Runs',
  'group-compliance-mode.latest-deployed-to-production': 'Latest Deployed to Production Runs',
  'group-compliance-mode.latest-release-candidate': 'Latest Release Candidate Runs',
  'group-compliance-mode.latest-released': 'Latest Released Runs',

  // connected pipelines
  'connected-pipelines.pipeline-details.no-pipeline-runs.general': 'No Pipeline Runs found',
  'connected-pipelines.pipeline-details.no-pipeline-runs.status-new':
    "Your delivery is still in status 'New'. Activate the delivery to see relevant pipeline runs.",
  'connected-pipelines.pipeline-details.no-pipeline-runs.status-released': 'No Pipeline Runs released in this delivery',
  'connected-pipelines.column-names.pipeline-key': 'Pipeline Key',
  'connected-pipelines.column-names.jira-components': 'Jira Components',
  'connected-pipelines.column-names.latest-run': `Latest Run For Selected View Mode ({{pipelineRunCountInMode}})`,

  'pipeline-list.unprocessed-files': 'There are unprocessed Files',
  'pipeline-list.pipeline-run.release-status.tooltip':
    'Latest Release Status of Pipeline Run. Pipeline Run can also have another (additional) Release Status',

  'pipeline-list.pipeline-run.execution-status.tooltip': 'Latest Execution Status of Pipeline Run.',
  'pipeline-list.pipelines-running.warning-box.single': 'Pipeline is currently running. Refresh the page to get the latest results.',
  'pipeline-list.pipelines-running.warning-box.multiple': 'Pipelines are currently running. Refresh the page to get the latest results.',
  'pipeline-list.unlink-pipeline.microdelivery':
    'Are you sure you want to unlink the pipeline <b>"{{ pipelinekey }}"</b> from the current Micro Delivery? <br/> Existing pipeline runs and the pipeline itself will not be deleted.',
  'pipeline-list.unlink-pipeline.delivery':
    'Are you sure you want to unlink the pipeline <b>"{{ pipelinekey }}"</b> from the current Delivery?  <br/> Existing pipeline runs and the pipeline itself will not be deleted.',
  'pipeline-list.button.pipeline-responsibles': 'Pipeline Responsibles',

  // button tooltips
  'button-tooltip.manage-pipeline.disabled-by-authorization':
    'You are not authorized to remove the selected pipeline.<br/><br/>You must be a workspace member with the role "owner" in Hyperspace portal or a pipeline responsible maintained in Hyperspace onboarding depending where your pipeline was setup.',
  'button-tooltip.manage-pipeline.disabled-by-mapping': 'Connected Pipelines are managed by Jira Component Mapping.',
  'button-tooltip.manage-pipeline.disabled-by-lock': 'Selected Delivery/Microdelivery is not active.',
  'button-tooltip.manage-pipeline.disabled-by-readonly':
    'You are not authorized to edit the selected delivery.<br/><br/>You must be a program member in Sirius and you must be a workspace member with the role "owner" in Hyperspace portal or a pipeline responsible maintained in Hyperspace onboarding depending where your pipeline was setup.',
  'button-tooltip.manage-pipeline.enabled-delivery-delete-message':
    'We will only unlink the pipeline from the current Delivery.\nExisting pipeline runs and the pipeline itself will not be deleted.',
  'button-tooltip.manage-pipeline.enabled-microdelivery-delete-message':
    'We will only unlink the pipeline from the current Microdelivery.\nExisting pipeline runs and the pipeline itself will not be deleted.',
  'pipeline.optimized.flag': 'OPTIMIZED PIPELINE',
  // optimized pipeline run
  'icon-tooltip.show-pipeline-deprecated': 'Related scheduled run should <strong>not</strong> be more than 24h prior to the selected run.',
  'pipeline.mode.2.flag': 'COMMIT RUN',
  'pipeline.mode.3.flag': 'SCHEDULED RUN',

  // Add Pipeline Dialog
  'pipeline.add.dialog.indicator.group': 'Group',
  'pipeline.add.dialog.indicator.pipeline': 'Pipeline',
  'add.pipeline.dialog.add.text.null': 'Add',
  'add.pipeline.dialog.add.text.pipeline': 'Add Pipeline',
  'add.pipeline.dialog.add.text.group': 'Add Group',

  // Policy Results
  'policy.result.group.summary.description': 'with executed policies',

  // Policy Usage
  'policy.usage.group.summary.description': 'executed',

  // Home Screen
  'home.screen.contact.summary': `You can contact us on Slack
      <a href='https://slack.com/app_redirect?channel=sap-tools-cumulus' rel='noopener noreferrer' target='_blank'>#sap-tools-cumulus</a> or
      create a
      <a
        href='https://itsm.services.sap/sp?id=sc_cat_item&sys_id=703f22d51b3b441020c8fddacd4bcbe2&sysparm_category=e15706fc0a0a0aa7007fc21e1ab70c2f&service_offering=815f03371b487410341e11739b4bcbed'
        rel='noopener noreferrer'
        target='_blank'
        >Service Now</a
      >.`,

  //! Change pipeline run release state dialog

  'release-candidate.revert-button.tooltip.release-candidate': "Revert current state 'release candidate' to previous state.",
  'release-candidate.revert-button.tooltip.released': "Selected pipeline run is not in state 'release candidate.'",
  'release-candidate.revert-button.tooltip.initial': "Selected pipeline run is not in state 'release candidate.'",
  'release-candidate.revert-button.tooltip.promoted': "Selected pipeline run is not in state 'release candidate.'",
  'release-candidate.revert-button.tooltip.deployed-to-production': "Selected pipeline run is not in state 'release candidate.'",

  'released.revert-button.tooltip.release-candidate': "Selected pipeline run is not in state 'released'.",
  'released.revert-button.tooltip.released': "Revert current state 'released' to previous state.",
  'released.revert-button.tooltip.initial': "Selected pipeline run is not in state 'released'.",
  'released.revert-button.tooltip.deployed-to-production': "Selected pipeline run is not in state 'released'.",
  'released.revert-button.tooltip.promoted': "Selected pipeline run is not in state 'released'.",

  'release-candidate.set-button-tooltip.release-candidate':
    "The selected pipeline run is already in state 'release candidate' for this (micro)delivery (group).",
  'release-candidate.set-button-tooltip.released':
    "Set state to 'release candidate' directly is not supported from current state 'released', only reverting released state.",
  'release-candidate.set-button-tooltip.initial': "Set current state to 'release candidate'.",
  'release-candidate.set-button-tooltip.promoted': "Set current state to 'release candidate'.",
  'release-candidate.set-button-tooltip.deployed-to-production': "Set current state to 'release candidate'.",

  'release.set-button.tooltip.release-candidate': "Set current state to 'released'.",
  'release.set-button.tooltip.released': "The selected pipeline run is already in state 'released' for this (micro)delivery (group).",
  'release.set-button.tooltip.initial': "Set current state to 'released'.",
  'release.set-button.tooltip.deployed-to-production': "Set current state to 'released'.",
  'release.set-button.tooltip.promoted': "Set current state to 'released'.",

  // Build / Repo information missing tooltip
  'build.repo.information.missing.tooltip': `
    <span> To provide the build / repository / branch information, you can use the following options:</span>
    <ul class="list-style margin-width">
      <li>
        <b>Piper sapGenerateEnvironmentInfo step</b> generates an <b>env.json</b> with the relevant information like e.g. the build
        url, the repository url, and the branch name. Using the Piper stage Init, the generation and upload works out-of-the-box if Piper
        sapCumulusUpload step is configured.
      </li>
      <li>
        The <b>pipeline execution status event</b> provides the information of e.g. build url and repository url.
        The event is sent at the <b>Piper Init/Build stage and in the Piper Post stage</b>
        if the pipeline is using the <b>Piper library and Vault as well as sapCumulusUpload step</b> is configured.
      </li>
    </ul>
    `,

  // Pipeline Responsibles Dialog
  'pipeline-responsibles.title': 'Pipeline Responsibles for {{ pipelineKey }}',
  'pipeline-responsibles.no-responsibles': 'No responsibles found for this pipeline.',
  'pipeline-responsibles.table.user-id': 'User ID',
  'pipeline-responsibles.select-all': 'Select all user IDs',
  'pipeline-responsibles.select-user': 'Select {{ userId }}',
  'pipeline-responsibles.button.copy-selected': 'Copy Selected User IDs',
  'pipeline-responsibles.button.copy-no-selection': 'Please select at least one user to copy',
  'pipeline-responsibles.button.mail-selected': 'Mail to Selected',
  'pipeline-responsibles.button.mail-no-selection': 'Please select at least one user to send email',
  'pipeline-responsibles.button.mail-no-emails': 'Please select at least one user with a known email address',
  'pipeline-responsibles.button.load-more': 'Load More ({{ count }} items)',
  'pipeline-responsibles.button.loading-more': 'Loading...',
  'pipeline-responsibles.button.export-selected': 'Export Selected',
  'pipeline-responsibles.button.export-no-selection': 'Please select at least one user to export',
  'pipeline-responsibles.copy.selected-success': 'Copied {{ count }} user IDs to clipboard',
  'pipeline-responsibles.copy.no-selection': 'Please select at least one user to copy',
  'pipeline-responsibles.copy.failed': 'Failed to copy to clipboard',
  'pipeline-responsibles.export.success': 'Successfully exported {{ count }} user IDs',
  'pipeline-responsibles.export.no-selection': 'Please select at least one user to export',
  'pipeline-responsibles.export.failed': 'Export failed',
  'pipeline-responsibles.error.loading-failed': 'Failed to load responsibles for this pipeline. Please try again later.',

  // Common
  'common.button.close': 'Close',
};
